// utils/flowplayerSuspend.ts
type FP = any;

const UA = navigator.userAgent || "";
export const isAndroidWebView =
  /Android/i.test(UA) && (/\bwv\b/.test(UA) || UA.includes(";UGGIYO_APP;"));

// jQuery가 있으면 jQuery로, 없으면 DOM만으로 "보이는" 컨테이너를 찾는다
function pickVisibleContainer(): HTMLElement | null {
  const w: any = window;
  if (w.jQuery) {
    const $ = w.jQuery;
    const vis = $(".flowplayer:visible").get(0);
    if (vis) return vis as HTMLElement;
    const any = $(".flowplayer").get(0);
    if (any) return any as HTMLElement;
  }
  const all = Array.from(document.querySelectorAll<HTMLElement>(".flowplayer"));
  const visible = all.find(el => {
    const rects = el.getClientRects();
    if (!rects || rects.length === 0) return false;
    const cs = getComputedStyle(el);
    return cs.visibility !== "hidden" && cs.display !== "none" &&
           (el.offsetWidth > 0 || el.offsetHeight > 0);
  });
  return visible || all[0] || null;
}

function getCurrentFP(): FP | null {
  const el = pickVisibleContainer();
  if (!el) return null;
  const w: any = window;
  // 공식 전역 함수 또는 엘리먼트에 붙어있는 참조
  return (w.flowplayer?.(el) ?? (el as any).flowplayer ?? null);
}

// 네트워크만 잠깐 멈춘다(과격한 unload/remove는 하지 않음)
function suspendFP(fp: FP) {
  const st: any = { wasPlaying: !!fp?.playing, t: 0 };
  try {
    const v: HTMLVideoElement | null =
      fp?.video?.tag || (fp?.container || fp?.root || document).querySelector?.("video");
    if (v) st.t = v.currentTime || 0;
  } catch {}
  try { fp?.engine?.hls?.stopLoad?.(); } catch {}
  try { fp?.pause?.(); } catch {}
  return st;
}

function resumeFP(fp: FP, st: any) {
  try { fp?.engine?.hls?.startLoad?.(); } catch {}
  try {
    const v: HTMLVideoElement | null =
      fp?.video?.tag || (fp?.container || fp?.root || document).querySelector?.("video");
    if (v && Number.isFinite(st?.t)) v.currentTime = st.t;
  } catch {}
  try { if (st?.wasPlaying) fp?.play?.(); } catch {}
}

// 중첩 요청도 안전하게: ref-count guard
class FPSuspendGuard {
  private count = 0;
  private fp: FP | null = null;
  private st: any = null;

  begin() {
    if (!isAndroidWebView) return;
    if (this.count++ === 0) {
      try {
        this.fp = getCurrentFP();
        if (this.fp) this.st = suspendFP(this.fp);
      } catch (e) {
        console.debug("[fp] begin error (ignored)", e);
      }
    }
  }

  end() {
    if (!isAndroidWebView) return;
    if (this.count > 0 && --this.count === 0) {
      try {
        if (this.fp) resumeFP(this.fp, this.st);
      } catch (e) {
        console.debug("[fp] end error (ignored)", e);
      } finally {
        this.fp = null;
        this.st = null;
      }
    }
  }
}
export const fpSuspendGuard = new FPSuspendGuard();
